import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { DayCard } from './day-card';

@JsonObject('model.time_card.TimeCard')
export class WeekCard extends AbstractModel {

    @JsonProperty(Number, 'id')
    id?: number;

    @JsonProperty([DayCard], 'days')
    days?: DayCard[];

    @JsonProperty(String, 'start')
    start?: string;

    @JsonProperty(String, 'finish')
    finish?: string;

    @JsonProperty(Number, 'overtime')
    overtime?: number;

}